// extracted by css-extract-rspack-plugin
export default {"cls1":"ButtonsPage-cls1_-nT","cls2":"ButtonsPage-cls2_r7V ButtonsPage-cls1_-nT"};